import React, { useState } from "react";
import Link from "next/link";

const Accordion = ({ data = null }) => {
  const [activeAccordion, setActiveAccordion] = useState(1);
  const toggleAccordion = (index) => {
    if (activeAccordion === index) {
      setActiveAccordion(null);
    } else {
      setActiveAccordion(index);
    }
  };

  return (
    <>
      {(data) &&
        <>
          {data?.map((item, index) => (
            <div key={index} className="accordion-item border-b bg-transparent border-0">
              <button
                onClick={() => toggleAccordion(index)}
                aria-expanded={activeAccordion === index}
                className="border-t button flex justify-between items-center relative border-b text-left w-full py-2 text-white text-base font-semibold outline-none bg-transparent"
              >
                <h3 className="text-lg font-semibold px-4">{item?.title}</h3>
                <span className="icon rounded-full absolute left-0 w-10 h-10 bg-white bg-opacity-25"></span>
              </button>
              <div
                className={`accordion-content max-h-0 overflow-hidden ${activeAccordion === index
                  ? "opacity-100 lg:max-h-full max-h-full bg-[#abd2ff33]"
                  : "opacity-0"
                  }`}>
                <p className="text-white text-base p-6 my-0">
                  {item?.content}
                </p>
              </div>
            </div>
          ))}
        </>
      }
    </>
  );
};

export default Accordion;
